export const fieldsConsultasEtce = [{
    key: "Numero",
    label: "Número",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: "text-center",
    sortable: true,
},
{
    key: "Tipo",
    label: "Tipo",
    tdClass: ["align-middle", "quebrarPorPalavra"],
    thClass: "text-center",
    sortable: true,
    formatter: (_value, _i, item) => `${item.Tipo ? item.Tipo + ': ' : ''}${item.TipoDocumento}`,
},
{
    key: "Assunto",
    label: "Assunto",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: "text-center",
    sortable: true,
},
{
    key: "Interessados",
    label: "Interessados",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
},
{
    key: "DataEntrada",
    label: "Data de Entrada",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: false
},
{
    key: "Julgado",
    label: "Julgado",
    formatter: (value) => value ? 'Sim' : 'Não',
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false
}
]